import React from "react";

// SHARED COMPONENTS START
import {
  Rayon,
  Slider,
  LargeCategoryView,
  CategorySlider,
  BrandList,
  LinkListview,
  SmallCategoryView,
  InstagramShowcase,
  SocialMedia,
  LargeBanner,
  MediumBanner,
  SmallBanner,
} from "shared-components/src/App";
// SHARED COMPONENTS END

import {
  IColorData,
  ColorList,
} from "../../../models/Design/colors/IGetColorsPageDataResponse";
import { IComponent } from "panel/src/Components/DragnDrop/Components";

import BannerEditForm from "panel/src/screens/Design/Home/EditForms/Banner";
import SliderEditForm from "panel/src/screens/Design/Home/EditForms/Slider";

import { ComponentType } from "panel/src/utils/enums/componentType";
import { PageType } from "panel/src/utils/enums/pageType";

const linkTypes = [
  { label: "Category", value: 1 },
  { label: "Product", value: 2 },
  { label: "Href", value: 3 },
  { label: "Web View URL", value: 4 },
  { label: "Search", value: 5 },
];

export const getComponent = (
  fontFamily: string,
  colorList: ColorList[],
  componentId: number,
  JSON: any,
  categories: { label: string; value: string }[]
) => {
  let component: IComponent | undefined;
  switch (componentId) {
    case ComponentType.Rayon:
      const rayonList = JSON;
      component = {
        componentId: ComponentType.Rayon,
        pageId: PageType.Home,
        componentTitle: "Rayon",
        component: (
          <Rayon
            fontFamily={fontFamily}
            colorList={colorList}
            imageResizeType={rayonList.imageResizeType}
            rayonList={rayonList}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.HomeSlider:
      component = {
        componentId: ComponentType.HomeSlider,
        pageId: PageType.Home,
        componentTitle: "Slider",
        component: (
          <Slider Items={JSON.Items} imageResizeType={JSON.imageResizeType} />
        ),
        editForm: {
          component: <SliderEditForm categories={categories} linkTypes={linkTypes} />,
          isShown: false,
          reRenderComponent: (editedJSON: any) =>
            getComponent(fontFamily, colorList, componentId, editedJSON, categories),
          rawFormData: JSON,
          editFormData: JSON,
        },
        preventEvents: true,
      };
      break;
    case ComponentType.LargeCategoryView:
      component = {
        componentId: ComponentType.LargeCategoryView,
        pageId: PageType.Home,
        componentTitle: "Large Category View",
        component: (
          <LargeCategoryView
            fontFamily={fontFamily}
            colorList={colorList}
            imageResizeType={JSON.imageResizeType}
            category={JSON}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.CategorySlider:
      component = {
        componentId: ComponentType.CategorySlider,
        pageId: PageType.Home,
        componentTitle: "Category Slider",
        component: (
          <CategorySlider
            fontFamily={fontFamily}
            colorList={colorList}
            imageResizeType={JSON.imageResizeType}
            categoryList={JSON}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.BrandList:
      component = {
        componentId: ComponentType.BrandList,
        pageId: PageType.Home,
        componentTitle: "Brand List",
        component: (
          <BrandList
            fontFamily={fontFamily}
            colorList={colorList}
            brands={JSON.Brands}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.LinkListView:
      component = {
        componentId: ComponentType.LinkListView,
        pageId: PageType.Home,
        componentTitle: "Link Listview",
        component: (
          <LinkListview
            fontFamily={fontFamily}
            colorList={colorList}
            linkList={JSON.Items}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.SmallCategoryView:
      component = {
        componentId: ComponentType.SmallCategoryView,
        pageId: PageType.Home,
        componentTitle: "Small Category View",
        component: (
          <SmallCategoryView
            fontFamily={fontFamily}
            colorList={colorList}
            categories={JSON.Categories}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.InstagramShowcase:
      component = {
        componentId: ComponentType.InstagramShowcase,
        pageId: PageType.Home,
        componentTitle: "Instagram Showcase",
        component: (
          <InstagramShowcase
            fontFamily={fontFamily}
            colorList={colorList}
            instagramImages={JSON}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.SocialMedia:
      let socialMediaData = JSON;
      component = {
        componentId: ComponentType.SocialMedia,
        pageId: PageType.Home,
        componentTitle: "Social Media Icons",
        component: (
          <SocialMedia
            fontFamily={fontFamily}
            colorList={colorList}
            socialMedias={socialMediaData.socialMediaPlatforms}
          />
        ),
        editForm: null,
        preventEvents: true,
      };
      break;
    case ComponentType.LargeBanner:
      component = {
        componentId: ComponentType.LargeBanner,
        pageId: PageType.Home,
        componentTitle: "Large banner",
        component: (
          <LargeBanner
            bannerInfo={JSON}
            imageResizeType={JSON.imageResizeType}
          />
        ),
        editForm: {
          component: (
            <BannerEditForm
              categories={categories}
              height="115"
              linkTypes={linkTypes}
            />
          ),
          isShown: false,
          reRenderComponent: (editedJSON: any) =>
            getComponent(fontFamily, colorList, componentId, editedJSON, categories),
          rawFormData: JSON,
          editFormData: JSON,
        },
        preventEvents: true,
      };
      break;
    case ComponentType.MediumBanner:
      component = {
        componentId: ComponentType.MediumBanner,
        pageId: PageType.Home,
        componentTitle: "Medium banner",
        component: (
          <MediumBanner
            bannerInfo={JSON}
            imageResizeType={JSON.imageResizeType}
          />
        ),
        editForm: {
          component: (
            <BannerEditForm categories={categories} height="65" linkTypes={linkTypes} />
          ),
          isShown: false,
          reRenderComponent: (editedJSON: any) =>
            getComponent(fontFamily, colorList, componentId, editedJSON, categories),
          rawFormData: JSON,
          editFormData: JSON,
        },
        preventEvents: true,
      };
      break;
    case ComponentType.SmallBanner:
      component = {
        componentId: ComponentType.SmallBanner,
        pageId: PageType.Home,
        componentTitle: "Small banner",
        component: (
          <SmallBanner
            bannerInfo={JSON}
            imageResizeType={JSON.imageResizeType}
          />
        ),
        editForm: {
          component: (
            <BannerEditForm categories={categories} height="37" linkTypes={linkTypes} />
          ),
          isShown: false,
          reRenderComponent: (editedJSON: any) =>
            getComponent(fontFamily, colorList, componentId, editedJSON, categories),
          rawFormData: JSON,
          editFormData: JSON,
        },
        preventEvents: true,
      };
      break;

    default:
      break;
  }
  return component;
};
